"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SearchField = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _SearchConfigurationProvider = require("../../containers/SearchConfigurationProvider");
var _hooks = require("../../hooks");
var _logger = require("../../logger");
var _models = require("../../models");
var _jsxRuntime = require("react/jsx-runtime");
const componentName = 'SearchField.tsx';
const Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        flexGrow: 1,
        justifyContent: 'center',
        padding: theme.spacing(6, 0, 6, 16),
        [theme.breakpoints.only('xs')]: {
            padding: theme.spacing(4, 0, 4, 9)
        }
    };
});
const SearchWrapper = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        alignItems: 'center',
        background: theme.palette.grey[100],
        borderRadius: 25,
        color: theme.palette.grey[900],
        display: 'flex',
        gap: theme.spacing(1),
        height: 45,
        padding: theme.spacing(0, 1, 0, 4),
        width: '100%'
    };
});
const SearchInput = (0, _mui.styled)('input')((param)=>{
    let { theme } = param;
    return {
        background: 'inherit',
        border: 0,
        height: '100%',
        width: '100%',
        '&::placeholder': {
            color: theme.palette.grey[300]
        },
        '&:focus': {
            outline: 'none'
        }
    };
});
const ClearIcon = (0, _mui.styled)(_icons.Clear)((param)=>{
    let { theme } = param;
    return {
        fontSize: '1.3rem',
        margin: theme.spacing(1)
    };
});
const preventMouseEvent = (e)=>e.preventDefault();
// TODO: Reduce props
const SearchField = (param)=>{
    let { isInstantResultEnabled, isInstantResultOpened, isMapLayoutShown, searchInputValue, searchTerm, selectFirstInstantResult, setCurrentListPage, setInstantResultChannelId, setInstantSearchTerm, setIsInstantResultOpened, setPickupPointsListType, setSearchInputValue, setSearchTerm } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    const { formatMessage } = (0, _hooks.useTranslations)();
    const { formattedSearchConfiguration, isInstantResultShown } = (0, _SearchConfigurationProvider.useSearchConfiguration)();
    const cancelLabel = formatMessage('cancel');
    const searchLabel = formatMessage('search');
    const listSearchPlaceholder = "".concat(searchLabel, " ").concat(formattedSearchConfiguration);
    const mapSearchPlaceholder = formatMessage('searchOnMap');
    const searchPlaceholder = isMapLayoutShown ? mapSearchPlaceholder : listSearchPlaceholder;
    const handleSearchTermChange = (0, _react.useCallback)((param)=>{
        let { target: { value } } = param;
        (0, _logger.logDebug)("".concat(componentName, " handleSearchTermChange(): Current search text value: '").concat(value, "'"));
        setSearchInputValue(value);
        // setting instant search term in case instant results are opened
        // same in case instant results are not enabled to track search term before user toggle to map
        if (isInstantResultOpened || !isInstantResultEnabled) {
            (0, _logger.logDebug)("".concat(componentName, " handleSearchTermChange(): Setting instantSearchTerm value to '").concat(value, "' ..."));
            setInstantSearchTerm(value);
        }
    }, [
        isInstantResultEnabled,
        isInstantResultOpened,
        setInstantSearchTerm,
        setSearchInputValue
    ]);
    const handleFocus = (0, _react.useCallback)(()=>{
        // TO-DO: open only when search text is set?
        if (isInstantResultEnabled) {
            (0, _logger.logDebug)("".concat(componentName, " handleFocus(): Showing instant results ..."));
            setIsInstantResultOpened(true);
        }
    }, [
        isInstantResultEnabled,
        setIsInstantResultOpened
    ]);
    const findPickupPoints = (0, _react.useCallback)(()=>{
        (0, _logger.logDebug)("".concat(componentName, ": findPickupPoints() called."));
        if (isInstantResultShown) {
            (0, _logger.logDebug)("".concat(componentName, ": Hiding instant results ..."));
            setIsInstantResultOpened(false);
        }
        setPickupPointsListType(_models.PickupPointsListType.List);
        if (searchInputValue) {
            (0, _logger.logDebug)("".concat(componentName, " findPickupPoints(): Current search text value: '").concat(searchInputValue, "'"));
            if (searchInputValue !== searchTerm) {
                (0, _logger.logDebug)("".concat(componentName, " findPickupPoints(): Setting searchTerm value to '").concat(searchInputValue, "' ..."));
                setSearchTerm(searchInputValue);
                setCurrentListPage(0);
            }
        }
    }, [
        isInstantResultShown,
        searchInputValue,
        searchTerm,
        setCurrentListPage,
        setIsInstantResultOpened,
        setPickupPointsListType,
        setSearchTerm
    ]);
    const handleSearch = (0, _react.useCallback)(()=>{
        if (isMapLayoutShown) {
            selectFirstInstantResult();
        } else {
            findPickupPoints();
        }
    }, [
        findPickupPoints,
        isMapLayoutShown,
        selectFirstInstantResult
    ]);
    const handlePressEnter = (0, _react.useCallback)((event)=>{
        if (event.key !== 'Enter') {
            return;
        }
        (0, _logger.logDebug)("".concat(componentName, ": handlePressEnter() called."));
        // TO-DO: don't search if search term is empty
        handleSearch();
        // TO-DO: logic behind the blur? necessary?
        const input = event.target;
        input.blur();
    }, [
        handleSearch
    ]);
    const clearSearchInput = (0, _react.useCallback)(()=>{
        setInstantResultChannelId(undefined);
        setSearchInputValue('');
        setInstantSearchTerm('');
        setSearchTerm('');
    }, [
        setInstantResultChannelId,
        setInstantSearchTerm,
        setSearchInputValue,
        setSearchTerm
    ]);
    return(/*#__PURE__*/ // TODO: Why two wrappers?
    (0, _jsxRuntime.jsx)(Root, {
        "data-testid": getTestId(_models.TestId.SearchFieldContainer),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(SearchWrapper, {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(SearchInput, {
                    type: "text",
                    placeholder: searchPlaceholder,
                    value: searchInputValue,
                    "data-testid": getTestId(_models.TestId.SearchInput),
                    onChange: handleSearchTermChange,
                    onFocus: handleFocus,
                    onKeyDown: handlePressEnter
                }),
                searchInputValue ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.IconButton, {
                    disableRipple: true,
                    "aria-label": cancelLabel,
                    color: "default",
                    variant: "text",
                    "data-testid": getTestId(_models.TestId.SearchClearButton),
                    onClick: clearSearchInput,
                    onMouseDown: preventMouseEvent,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClearIcon, {})
                }) : null,
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.IconButton, {
                    "aria-label": searchLabel,
                    color: "primary",
                    variant: "contained",
                    disabled: !searchInputValue,
                    onClick: handleSearch,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icons.Search, {})
                })
            ]
        })
    }));
};
exports.SearchField = SearchField;
